import { useEffect } from "react";

import FormFieldViewText from "components/FormFields/ViewText";
import { Space } from "components/icons/generated";
import MetaInfoListItem from "components/MetaInfoList/Item";
import TagsList from "components/TagsList";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import { TrackAnalyticsEventProperties } from "shared/Analytics";

import { AiIntegrationView } from "../../useSearchAiIntegrations/gql";

type AiIntegrationDetailsProps = {
  integration: AiIntegrationView;
  trackAnalytics: (event: string, props?: TrackAnalyticsEventProperties) => void;
};

const AiIntegrationDetailsDrawer = createDrawer(
  ({ integration, trackAnalytics }: AiIntegrationDetailsProps) => {
    useEffect(() => {
      trackAnalytics("Open Integration Details", { type: "ai" });
    }, [trackAnalytics]);

    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Details" />
          <DrawerCloseIcon />
        </DrawerHeader>

        <DrawerBody>
          <FormFieldViewText label="Name" value={integration.name} />

          <FormField label="Space">
            <MetaInfoListItem
              icon={Space}
              linkText={integration.space.name}
              href={`/spaces/${integration.space.id}`}
            />
          </FormField>

          {integration.description && (
            <FormFieldViewText label="Description" value={integration.description} />
          )}

          <FormFieldViewText label="Provider" value={integration.provider} />

          <FormFieldViewText label="Model" value={integration.model} />

          {integration.labels.length > 0 && (
            <FormField label="Labels">
              <TagsList tags={integration.labels} />
            </FormField>
          )}
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showAiIntegrationDetailsDrawer = createDrawerTrigger(AiIntegrationDetailsDrawer);
